import { Box, Stack, Text } from "@chakra-ui/layout";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { useToast } from "@chakra-ui/toast";
import axios from "axios";
import { useEffect, useState } from "react";
import { getSender } from "../config/ChatLogics";
import ChatLoading from "./ChatLoading";
import { Button } from "@chakra-ui/react";
import { ChatState } from "../Context/ChatProvider";
import { Tooltip } from "@chakra-ui/tooltip";
import { Input } from "@chakra-ui/input";
import { Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/menu";
import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
} from "@chakra-ui/modal";
import { BellIcon, ChevronDownIcon } from "@chakra-ui/icons";
import { FiBell } from "react-icons/fi";
import { Avatar } from "@chakra-ui/avatar";
import { a, useNavigate } from "react-router-dom";
import { Spinner } from "@chakra-ui/spinner";
// import ProfileModal from "./ProfileModal";
import NotificationBadge from "react-notification-badge";
import { Effect } from "react-notification-badge";
// import UserListItem from "../userAvatar/UserListItem";
import { Drawer as MaterialDrawer } from "@material-ui/core";
import UserListItem from "./userAvatar/UserListItem";
import useWindowDimensions from "../../CustomHooks/useWindowdimension";
import Button1 from "../../components/ResubleComp/Button";
const MyChats = ({
  fetchAgain,
  isDrawerOpen,
  handleCloseDrawer,
  isOpen,
  onOpen,
  onClose,
}) => {
  const { height, width } = useWindowDimensions();
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [loggedUser, setLoggedUser] = useState();
  const [search, setSearch] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingChat, setLoadingChat] = useState(false);
  const [isOpend, setIsOpen] = useState(false);
  // const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const token = localStorage.getItem("TOKEN");

  const handleDrawerClose = () => {
    setIsOpen(false);
  };
  const {
    setSelectedChat,
    user,
    notification,
    setNotification,
    chats,
    setChats,
    selectedChat,
  } = ChatState();
  console.log("chatsss", chats);
  const toast = useToast();
  const history = useNavigate();

  const logoutHandler = () => {
    localStorage.removeItem("userINfo");
    history("/");
  };

  const handleSearch = async () => {
    if (!search) {
      toast({
        title: "Please Enter something in search",
        status: "warning",
        duration: 5000,
        isClosable: true,
        position: "top-left",
      });
      return;
    }

    try {
      setLoading(true);

      const config = {
        headers: {
          Authorization: token,
        },
      };

      const { data } = await axios.get(
        `${baseUrl}/api/user?search=${search}`,
        config
      );

      setLoading(false);
      setSearchResult(data);
    } catch (error) {
      toast({
        title: "Error Occured!",
        description: "Failed to Load the Search Results",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
    }
  };

  const accessChat = async (userId) => {
    console.log(userId);

    try {
      setLoadingChat(true);
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: token,
        },
      };
      const { data } = await axios.post(
        `${baseUrl}/api/chat`,
        { userId },
        config
      );
      console.log("dataaa", data);
      if (!chats.find((c) => c._id === data._id)) setChats([data, ...chats]);
      setSelectedChat(data);
      setLoadingChat(false);
      onClose();
    } catch (error) {
      toast({
        title: "Error fetching the chat",
        description: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
    }
  };
  // const { selectedChat, setSelectedChat, user, chats, setChats } = ChatState();
  // const toast = useToast();

  const fetchChats = async () => {
    // console.log(user._id);
    try {
      const config = {
        headers: {
          Authorization: token,
        },
      };

      const { data } = await axios.get(baseUrl + "/api/chat", config);
      setChats(data);
      console.log("fecthchcats", data);
    } catch (error) {
      toast({
        title: "Error Occured!",
        description: "Failed to Load the chats",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
    }
  };

  useEffect(() => {
    setLoggedUser(JSON.parse(localStorage.getItem("userINfo")));
    fetchChats();
    // eslint-disable-next-line
  }, [fetchAgain]);

  //  const handleCloseDrawer = ()=>{
  //   setIsDrawerOpen(false)
  //  }

  return (
    <Box
      d={{ base: selectedChat ? "none" : "flex", md: "flex" }}
      flexDir="column"
      alignItems="center"
      overflow="scroll"
      p={3}
      bg="white"
      w={{ base: "100%", md: "31%" }}
      borderRadius="lg"
      borderWidth="1px"
    >
      <>
        <Box
          className="flex justify-between"
          style={{ display: width > 768 ? "block" : "none" }}
          bg="white"
          p="5px 10px 5px 10px"
          borderWidth="2px"
        >
          <Tooltip label="Search Users to chat" hasArrow placement="bottom-end">
            <span onClick={handleCloseDrawer}>
              <Button1
                primary
                className="px-3 py-3 rounded-md"
                onClick={onOpen}
              >
                Search User
              </Button1>
            </span>
          </Tooltip>
          {/* <div> */}
          <Menu>
            <MenuButton p={1} className="notificationbutton">
              <NotificationBadge
                count={notification.length}
                effect={Effect.SCALE}
                className="ml-20"
              />
              <FiBell size={24} />
            </MenuButton>
            <MenuList pl={2}>
              {!notification.length && "No New Messages"}
              {notification.map((notif) => (
                <MenuItem
                  key={notif._id}
                  onClick={() => {
                    setSelectedChat(notif.chat);
                    setNotification(notification.filter((n) => n !== notif));
                  }}
                >
                  {notif.chat.isGroupChat
                    ? `New Message in ${notif.chat.chatName}`
                    : `New Message from ${getSender(user, notif.chat.users)}`}
                </MenuItem>
              ))}
            </MenuList>
          </Menu>
        </Box>
        {/* search drawer */}
        <Drawer placement="left" onClose={onClose} isOpen={isOpen}>
          <DrawerOverlay />
          <DrawerContent>
            <DrawerHeader>Search Users</DrawerHeader>
            <DrawerBody>
              <Box d="flex" pb={2}>
                <Input
                  placeholder="Search by name or email"
                  mr={2}
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
                <Box d="flex" flexDirection="row">
                  <Button
                    onClick={handleSearch}
                    mt={2}
                    className="notificationbutton cursor-pointer"
                  >
                    Go
                  </Button>
                  <Button
                    onClick={onClose}
                    ml={2}
                    mt={2}
                    className="notificationbutton cursor-pointer"
                  >
                    Close
                  </Button>
                </Box>
              </Box>
              {loading ? (
                <ChatLoading />
              ) : (
                searchResult?.map((user) => (
                  <UserListItem
                    key={user._id}
                    user={user}
                    handleFunction={() => accessChat(user._id)}
                  />
                ))
              )}
              {loadingChat && <Spinner ml="auto" d="flex" />}
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      </>
      <Box className="drawerHide">
        <Box
          pb={3}
          px={3}
          fontSize={{ base: "28px", md: "30px" }}
          fontFamily="Work sans"
          d="flex"
          w="100%"
          justifyContent="space-between"
          alignItems="center"
        >
          My Chats
        </Box>
        <Box
          d="flex"
          flexDir="column"
          p={3}
          bg="#F8F8F8"
          w="100%"
          h="80%"
          borderRadius="lg"
          overflowY="scroll"
        >
          {chats ? (
            <Stack overflowY="scroll">
              {chats.map((chat) => (
                <Box
                  onClick={() => setSelectedChat(chat)}
                  cursor="pointer"
                  bg={selectedChat === chat ? "#38B2AC" : "#E8E8E8"}
                  color={selectedChat === chat ? "white" : "black"}
                  px={3}
                  py={2}
                  borderRadius="lg"
                  key={chat._id}
                >
                  <div className="flex gap-2">
                    <img
                      // src={chat?.users[1]?.userProfileImageUrl}
                      src={
                        chat.users[0]._id === loggedUser._id
                          ? chat.users[1]?.userProfileImageUrl
                          : chat.users[0]?.userProfileImageUrl
                      }
                      className="w-9 h-9 rounded-full"
                      alt=""
                    />
                    <div
                      className="flex flex-col items-start"
                      onClick={handleCloseDrawer}
                    >
                      <Text onClick={handleCloseDrawer}>
                        {!chat?.isGroupChat
                          ? getSender(loggedUser, chat?.users)
                          : chat.chatName}
                      </Text>
                      {chat?.latestMessage && (
                        <Text fontSize="xs">
                          <b>{chat?.latestMessage?.sender?.name} : </b>
                          {chat?.latestMessage?.content?.length > 10
                            ? chat?.latestMessage?.content?.substring(0, 20) +
                              "..."
                            : chat?.latestMessage?.content}
                        </Text>
                      )}
                    </div>
                  </div>
                </Box>
              ))}
            </Stack>
          ) : (
            <ChatLoading />
          )}
        </Box>
      </Box>

      {/* drawer part */}
      <MaterialDrawer
        anchor="right"
        open={isDrawerOpen}
        PaperProps={{ style: { width: "100vw" } }}
        style={{ display: width > 768 ? "none" : "block", marginTop: "200px" }}
      >
        <Box
          className="twoboxes"
          bg="white"
          p="5px 10px 5px 10px"
          borderWidth="2px"
        >
          <a href="/" onClick={handleCloseDrawer}>
            <HomeOutlinedIcon sx={{ height: "40px", width: "40px" }} />
          </a>
          <Tooltip label="Search Users to chat" hasArrow placement="bottom-end">
            <span onClick={handleCloseDrawer}>
              <Button1
                primary
                className="px-3 py-3 rounded-md"
                onClick={onOpen}
              >
                Search User
              </Button1>
            </span>
          </Tooltip>
          {/* <div> */}
          <Menu>
            <MenuButton p={1} className="notificationbutton">
              <NotificationBadge
                count={notification.length}
                effect={Effect.SCALE}
              />
              <FiBell size={24} />
            </MenuButton>
            <MenuList pl={2}>
              {!notification.length && "No New Messages"}
              {notification.map((notif) => (
                <MenuItem
                  key={notif._id}
                  onClick={() => {
                    setSelectedChat(notif.chat);
                    setNotification(notification.filter((n) => n !== notif));
                  }}
                >
                  {notif.chat.isGroupChat
                    ? `New Message in ${notif.chat.chatName}`
                    : `New Message from ${getSender(user, notif.chat.users)}`}
                </MenuItem>
              ))}
            </MenuList>
          </Menu>
        </Box>
        <Box
          pb={3}
          px={3}
          fontSize={{ base: "28px", md: "30px" }}
          fontFamily="Work sans"
          d="flex"
          w="100%"
          justifyContent="space-between"
          alignItems="center"
        >
          My Chats
        </Box>
        <Box
          d="flex"
          flexDir="column"
          p={3}
          bg="#F8F8F8"
          w="100%"
          h="80%"
          borderRadius="lg"
          overflowY="scroll"
        >
          {chats ? (
            <Stack overflowY="scroll">
              {chats.map((chat) => {
                return (
                  <>
                    <Box
                      onClick={() => setSelectedChat(chat)}
                      cursor="pointer"
                      bg={selectedChat === chat ? "#38B2AC" : "#E8E8E8"}
                      color={selectedChat === chat ? "white" : "black"}
                      px={3}
                      py={2}
                      borderRadius="lg"
                      // key={chat._id}
                    >
                      <div className="flex gap-2">
                        <img
                          src={
                            chat.users[0]._id === loggedUser._id
                              ? chat.users[1]?.userProfileImageUrl
                              : chat.users[0]?.userProfileImageUrl
                          }
                          className="w-9 h-9 rounded-full"
                          alt=""
                        />
                        <div
                          className="flex flex-col items-start"
                          onClick={handleCloseDrawer}
                        >
                          <Text onClick={handleCloseDrawer}>
                            {!chat.isGroupChat
                              ? getSender(loggedUser, chat.users)
                              : chat.chatName}
                          </Text>
                          {chat.latestMessage && (
                            <Text fontSize="xs">
                              <b onClick={handleCloseDrawer}>
                                {chat.latestMessage.sender.name} :{" "}
                              </b>
                              {chat.latestMessage.content.length > 10
                                ? chat.latestMessage.content.substring(0, 20) +
                                  "..."
                                : chat.latestMessage.content}
                            </Text>
                          )}
                        </div>
                      </div>
                    </Box>
                  </>
                );
              })}
            </Stack>
          ) : (
            <ChatLoading />
          )}
        </Box>
      </MaterialDrawer>
    </Box>
  );
};

export default MyChats;
